<template>
  <div class="application-list">
    <form action="/" :class="!training ? 'form-top form-flex' : 'form-flex'">
      <van-search v-model="value" right-icon="" placeholder="请输入进修中心名称" @input="onHospitalEnter">
        <template #label>
          <div class="left-select" @click="onShowCityList">
            <div v-if="trueCitys != ''" class="left-select-word">
              {{ trueCitys }}
            </div>
            <div v-if="trueCitys == ''" class="left-select-words">
              <img class="search-bottom-img" src="../../assets/images/application-study/loaction.png" alt="" />
              定位
            </div>
            <div class="wire"></div>
          </div>
        </template>
        <template #left-icon>
          <div><van-icon name="search" /></div>
        </template>
      </van-search>
      <!-- <div v-if="hospitalTopList.status != 0 && training" class="search-bottom-passhos">
        <div class="search-bottom-passhos-title">
          <span class="hospitalName">{{ hospitalTopList.hospitalName }}</span>
          <span v-if="hospitalTopList.status == 1 || hospitalTopList.status == 2"
            class="search-bottom-passhos-title-audit">审核中</span>
          <span v-if="hospitalTopList.status == 4" class="search-bottom-passhos-title-passed">已通过</span>
        </div>
        <div class="search-bottom-passhos-bottomword">
          {{
            hospitalTopList.summary == ''
            ? '暂无医院简介'
            : hospitalTopList.summary == undefined
              ? '暂无医院简介'
              : hospitalTopList.summary
          }}
        </div>
      </div> -->
    </form>
    <div v-if="hospitalList.length" :class="
      !training
        ? 'bind-none bind-hospital'
        : !showList
          ? 'bind-hospitals'
          : 'bind-hospital'
    ">
      <div v-for="(item, index) in hospitalList" :key="index" class="search-bottom-passhos" @click="clickHostipal(item.id)">
        <div class="search-bottoms">
          <div class="search-bottom-passhos-title">
            <span class="hospitalName">{{ item.name }}</span>
            <!-- <span>空位名额：
              <span style="color: #379fff">{{ item.assignCount }}</span>
            </span> -->
          </div>
          <div class="search-bottom-passhos-bottomword">
            {{
              item.intro == ''
              ? '暂无医院简介'
              : item.intro == undefined
                ? '暂无医院简介'
                : item.intro
            }}
          </div>
        </div>
      </div>
    </div>
    <EmptyView class="empty-view" v-if="hospitalList.length == 0 && hospitalTopList.hospitalName == ''" title="暂无数据" />
    <Location :isShow="show" :trueCityParam="trueCity" :cityListParam="cityList" :valueParam="value"
      :bindCityStatusParam="bindCityStatus" :cityShowParam="cityShow" @onCityEnter="onCityEnter"
      @onCityCanel="onCityCanel" @onClickCity="onClickCity" @onClosePopup="onCityCanel"></Location>
  </div>
</template>

<script>
import EmptyView from '../../components/EmptyView.vue'
import Location from './components/location.vue'
import { locationList, educationList } from '@/api/education.js'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'ApplicationList',
  components: {
    EmptyView,
    Location
  },
  data () {
    return {
      hospitalTopList: {
        hospitalId: '',
        hospitalName: '',
        status: 0,
        summary: ''
      },
      hospitalCount: 0,
      hospitalList: [],
      showList: false,
      cityList: [],
      bindCityStatus: 1,
      trueCitys: '',
      trueCity: '',
      trueCitysId: '',
      trueHopitalsNmae: '',
      show: false,
      cityShow: true,
      value: '',
      cityName: '',
      training: true
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    roleType () {
      return this.$store.getters.userInfo.roles[0]
    },
    roles () {
      return ['johnson-employee', 'senior-director', 'senior-director-goal-doctor', 'lecturer']
    }
  },
  mounted () {
    this.handleGetLocation()
    this.applicationHospitalList()
  },
  methods: {
    // 获取城市列表
    handleGetLocation () {
      locationList({ cityName: this.cityName }).then(res => {
        this.cityList = res.data
      })
    },
    // 搜索进修医院列表方法
    applicationHospitalList () {
      educationList({
        cityCode: this.trueCitysId,
        name: this.value
      }).then(res => {
        this.hospitalList = res.data.hospitalEducations
      })
    },
    // 搜索城市列表方法
    applicationSelectCityList () {
      console.log('applicationSelectCityList method')
    },
    // 点击左侧下拉按钮展示城市搜索列表
    onShowCityList () {
      if (this.trueCitys === '') {
        this.bindCityStatus = 1
      } else {
        this.bindCityStatus = 1
      }
      this.show = true
    },
    // 城市列表点击取消时触发
    onCityCanel () {
      this.show = false
    },
    // 城市搜索输入框内容变化时触发
    onCityEnter (value) {
      this.cityName = value
      this.handleGetLocation()
    },
    // 医院搜索输入框内容变化时触发
    onHospitalEnter (value) {
      this.trueHopitalsNmae = value
      this.applicationHospitalList()
    },
    // 点击列表医院触发跳转
    clickHostipal (hospitalId) {
      console.log(hospitalId)
      this.$router.push({
        path: '/application-study/learning-details',
        query: {
          hospitalId: hospitalId,
        }
      })
    },
    // 点击列表城市触发
    onClickCity (value) {
      this.show = false
      this.trueCitys = value.cityName
      this.trueCitysId = value.cityCode
      this.applicationHospitalList()
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.application-list {
  background-color: #ffffff;
  min-height: 100vh;
  position: relative;

  .form-flex {
    position: fixed;
    top: 0px;
    width: 100%;

    &.form-top {
      top: 50px;
    }

    // 搜索框左侧城市选择样式
    .left-select {
      display: flex;
      align-items: center;
      flex-direction: row;
      // width: 56px;
      height: 34px;
      line-height: 34px;

      //   padding: 6px 0;
      // 搜索框左侧城市选择文字样式
      .left-select-word {
        font-weight: 500;
        color: #1f333f;
        display: flex;
        font-size: 13px;
      }

      // 搜索框左侧城市选择图标样式
      .left-select-words {
        color: #1f333f;
        display: flex;
        font-size: 13px;
        font-weight: 500;
        color: #1f333f;

        // line-height: 21px;
        .search-bottom-img {
          margin-top: 12px;
          margin-right: 4px;
          width: 10px;
          height: 10px;
        }
      }

      // 搜索框左侧城市选择倒三角样式
      .corner {
        margin-left: 4px;
        margin-top: 6px;
        display: flex;
        width: 0px;
        /*  宽⾼设置为0，很重要，否则达不到效果 */
        height: 4px;
        border: 6px solid #1f333f;
        border-bottom-color: transparent;
        /* 设置透明背景⾊ */
        border-left-color: transparent;
        border-right-color: transparent;
      }

      // 搜索框左侧城市选择右边竖线样式
      .wire {
        content: '';
        /* 莫得东西，边框嘛，不需要内容 */
        display: flex;
        margin-left: 13px;
        width: 1px;
        height: 14px;
        background: #cccccc;
      }
    }

    // 搜索框底部文字样式
    .search-bottom {
      margin: 0 14px;
      line-height: 12px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      justify-items: center;

      .search-left {
        display: flex;
        justify-items: center;
      }

      // 搜索框底部文字左边图标样式
      .search-bottom-img {
        width: 12px;
        height: 12px;
        line-height: 12px;
        display: inline-block;
      }

      // 搜索框底部文字中间文字样式
      .search-bottom-mark-word {
        height: 12px;
        font-size: 11px;
        font-weight: 500;
        color: #fe6a23;
        margin-left: 4px;
        display: inline-block;
      }

      // 搜索框底部文字中间文字样式
      .search-bottom-mark-hos {
        //width: 220px;
        height: 12px;
        font-size: 11px;
        font-weight: 500;
        color: #fe6a23;
        display: inline-block;
        text-align: right;
      }

      .search-bottom-mark-hoss {
        width: 351px;
        height: 12px;
        font-size: 11px;
        font-weight: 500;
        color: #fe6a23;
        display: inline-block;
        text-align: right;
      }
    }

    // 搜索框底部文字样式
    .search-bottoms {
      margin: 0 14px;
      line-height: 12px;
      background: #ffffff;
      text-align: right;
      display: flex;
      justify-content: space-between;
      justify-items: center;

      .search-left {
        display: flex;
        justify-items: center;
      }

      // 搜索框底部文字中间文字样式
      .search-bottom-mark-hos {
        //width: 220px;
        height: 12px;
        font-size: 11px;
        font-weight: 500;
        color: #fe6a23;
        display: inline-block;
        text-align: right;
      }
    }

    // 搜索框底部固定医院样式
    .search-bottom-passhos {
      // height: 91px;
      margin: 0px 14px 0 14px;
      padding-top: 21px;
      border-bottom: 1px solid #eeeeee;
      background: #ffffff;

      // 搜索框底部固定医院标题样式
      .search-bottom-passhos-title {
        font-size: 15px;
        font-weight: bold;
        color: #1f333f;

        .hospitalName {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          max-width: 220px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        // 搜索框底部固定医院标题审核中样式
        .search-bottom-passhos-title-audit {
          width: 34px;
          height: 14px;
          background: #ffa03c;
          border-radius: 2px;
          font-size: 9px;
          font-weight: 500;
          color: #ffffff;
          margin-left: 6px;
          padding: 2px;
        }

        // 搜索框底部固定医院标题已通过样式
        .search-bottom-passhos-title-passed {
          width: 34px;
          height: 14px;
          background: #20be69;
          border-radius: 2px;
          font-size: 9px;
          font-weight: 500;
          color: #ffffff;
          margin-left: 6px;
          padding: 3px 4px;
        }
      }

      // 搜索框底部固定医院内容样式
      .search-bottom-passhos-bottomword {
        height: 30px;
        font-size: 11px;
        font-weight: 500;
        color: #666666;
        margin: 4px 0 16px 0;
        //text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }
  }

  // 需绑定的医院
  .bind-hospital {
    margin-top: 166px;
    height: calc(100vh - 166px);

    .search-bottom-passhos {
      display: flex;
      flex-direction: row;
      // height: 86px;
      margin: 0 14px;
      padding: 16px 0px;
      border-bottom: 1px solid #eeeeee;

      // 搜索框底部固定医院标题样式
      .search-bottom {
        width: 305px;

        .search-bottom-passhos-title {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          //height: 14px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          justify-items: center;

          .hospitalName {
            font-size: 15px;
            font-weight: bold;
            color: #1f333f;
            max-width: 220px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          span {
            font-size: 11px;
            font-weight: 500;
            color: #1f333f;
          }
        }

        // 搜索框底部固定医院内容样式
        .search-bottom-passhos-bottomword {
          line-height: 18px;
          font-size: 11px;
          font-weight: 500;
          color: #666666;
          margin-top: 4px;
          // height: 30px;
          //text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
      }

      .search-bottoms {
        width: 349px;

        .search-bottom-passhos-title {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          //height: 14px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          justify-items: center;

          .hospitalName {
            font-size: 15px;
            font-weight: bold;
            color: #1f333f;
            max-width: 220px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          span {
            font-size: 11px;
            font-weight: 500;
            color: #1f333f;
          }
        }

        // 搜索框底部固定医院内容样式
        .search-bottom-passhos-bottomword {
          line-height: 18px;
          font-size: 11px;
          font-weight: 500;
          color: #666666;
          margin-top: 4px;
          // height: 30px;
          //text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
      }
    }

    .search-bottom-passhoss {
      // height: 66px;
      margin: 0 14px;
      padding: 16px 0px;
      border-bottom: 1px solid #eeeeee;

      // 搜索框底部固定医院标题样式
      .search-bottom-passhos-title {
        font-size: 15px;
        font-weight: bold;
        color: #1f333f;

        //height: 14px;
        .hospitalName {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          max-width: 220px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      // 搜索框底部固定医院内容样式
      .search-bottom-passhos-bottomword {
        line-height: 18px;
        font-size: 11px;
        font-weight: 500;
        color: #666666;
        margin: 4px 0 0px 0;
      }
    }
  }

  .bind-none {
    height: calc(100vh - 120px);
    padding-top: 120px;
    box-sizing: border-box;
    margin-top: 0;
  }

  .bind-hospitals {
    padding-top: 70px;
    box-sizing: border-box;
    height: calc(100vh - 70px);

    .search-bottom-passhos {
      display: flex;
      flex-direction: row;
      // height: 86px;
      margin: 0 14px;
      padding: 16px 0px;
      border-bottom: 1px solid #eeeeee;

      .search-bottom-passhos-sort {
        width: 24px;
        height: 18px;
        background: #f5f5f5;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 500;
        color: #1f333f;
        margin-right: 14px;
        margin-top: 14px;
        text-align: center;
        line-height: 18px;
      }

      .search-bottom {
        width: 305px;

        // 搜索框底部固定医院标题样式
        .search-bottom-passhos-title {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          //height: 14px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          justify-items: center;

          .hospitalName {
            font-size: 15px;
            font-weight: bold;
            color: #1f333f;
            max-width: 220px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          span {
            font-size: 11px;
            font-weight: 500;
            color: #1f333f;
          }
        }

        // 搜索框底部固定医院内容样式
        .search-bottom-passhos-bottomword {
          line-height: 18px;
          font-size: 11px;
          font-weight: 500;
          //height: 30px;
          color: #666666;
          margin-top: 4px;
          //text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
      }

      .search-bottoms {
        width: 349px;

        // 搜索框底部固定医院标题样式
        .search-bottom-passhos-title {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          //height: 14px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          justify-items: center;

          .hospitalName {
            font-size: 15px;
            font-weight: bold;
            color: #1f333f;
            max-width: 220px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          span {
            font-size: 11px;
            font-weight: 500;
            color: #1f333f;
          }
        }

        // 搜索框底部固定医院内容样式
        .search-bottom-passhos-bottomword {
          line-height: 18px;
          font-size: 11px;
          font-weight: 500;
          //height: 30px;
          color: #666666;
          margin-top: 4px;
          //text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
      }
    }

    .search-bottom-passhoss {
      // height: 66px;
      margin: 0 14px;
      padding: 16px 0px;
      border-bottom: 1px solid #eeeeee;

      // 搜索框底部固定医院标题样式
      .search-bottom-passhos-title {
        font-size: 15px;
        font-weight: bold;
        color: #1f333f;

        //height: 14px;
        .hospitalName {
          font-size: 15px;
          font-weight: bold;
          color: #1f333f;
          max-width: 220px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      // 搜索框底部固定医院内容样式
      .search-bottom-passhos-bottomword {
        line-height: 18px;
        font-size: 11px;
        font-weight: 500;
        //height: 30px;
        color: #666666;
        margin: 4px 0 0px 0;
      }
    }
  }
}

// 搜索框外层整体样式
/deep/ .van-search {
  padding: 14px;
  width: 100%;
}

// 搜索框整体样式
/deep/ .van-search__content {
  background: #f5f5f5;
  width: 351px;
  border-radius: 6px;
  padding-left: 0px;
}

// 左侧label样式
/deep/ .van-search__label {
  padding-left: 0px;
  margin-left: 12px;
}

// 左侧图标样式
/deep/ .van-field__left-icon {
  margin-left: 12px;
  margin-right: 6px;
}

// placeholder内文字样式
/deep/ .van-field__control {
  font-weight: 500;
  color: #bbbbbb;
  font-size: 13px;
}

// placeholder内文字样式
/deep/ .van-search__field {
  background-color: transparent !important;
  padding: 5px 10px 5px 0px;
}

/deep/ .empty-view {
  min-height: 100vh;
  max-height: 100vh;
}

/deep/ .van-cell {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/application-study/application-list.vue